module.exports = __webpack_public_path__ + "static/media/YF07_3.796e6374.jpg";